import { render, staticRenderFns } from "./ContentEntryResources.vue?vue&type=template&id=68dfa508&scoped=true&"
import script from "./ContentEntryResources.vue?vue&type=script&lang=js&"
export * from "./ContentEntryResources.vue?vue&type=script&lang=js&"
import style0 from "./ContentEntryResources.vue?vue&type=style&index=0&id=68dfa508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dfa508",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VForm,VRow})
